import React, { useState, useEffect } from 'react'
import './employee-registration.css'
import { Button } from '@mui/material'
import { detailsField } from '../../services/employeeFieldType';
import { Controller, useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { prefixString } from '../../services/constant';
import { useNavigate } from 'react-router';
import { postEmployee } from '../../api-services/employee-services';
import FetchApi from '../../fetch-api/fetch-api';
import { SnackbarService } from '../../services/snackBehaviorSubject/snackBehaviorSubject';
import { Grid } from '@material-ui/core';
import ButtonWrapper from '../../widgets/button/button';


interface EmployeeRegistrationProps {
    editableEmployee?: any;
    renderEditEmployee?: boolean;
}

interface FieldValueProps {
    name: string;
    contact_no: string;
    grossSalary: string;
    officialEmail: string;
    roles: string;
    personalEmail?: string;
    designation?: string;
    blood_group?: string;
    DOB?: string;
    agendaRequired?: string | boolean;
    workupdateRequired?: string | boolean;
    jobRole?: string;
    educationalQualification?: string;
    technologyStack?: string;
    yearsOfExperience?: string | number;
    lastOrganizationWorked?: string;
    employeeTag?: string;
    aadharNumber?: string;
    panNumber?: string;
    permanentStreet?: string;
    permanentCity?: string;
    permanentState?: string;
    permanentPincode?: string | number;
    permanentCountry?: string;
    residentialStreet?: string;
    residentialCity?: string;
    residentialState?: string;
    residentialPincode?: string | number;
    residentialCountry?: string;
    alternativePhoneNumber?: string | number;
    bankName?: string;
    accountNumber?: string;
    ifscCode?: string;
    uan?: string;
    esicNo?: string;
    employeeType?: string;
}
interface employeeDetailsOptionProps {
    value: string,
    label: string
}
interface employeeDetailsProps {
    name: string;
    type: string;
    label: string;
    options?: employeeDetailsOptionProps[];
    required?: boolean;
}

const EmployeeRegistration = (props: EmployeeRegistrationProps) => {
    const snackbarService = SnackbarService()
    const prefix = prefixString()
    const [fieldValue, setFieldValue] = useState<FieldValueProps>({
        name: "",
        contact_no: "",
        grossSalary: "",
        officialEmail: "",
        roles: '',
        personalEmail: "",
        designation: "",
        blood_group: "",
        DOB: "",
        agendaRequired: false,
        workupdateRequired: false,
        jobRole: "",
        educationalQualification: "",
        technologyStack: "",
        yearsOfExperience: "",
        lastOrganizationWorked: "",
        employeeTag: "",
        aadharNumber: "",
        panNumber: "",
        permanentStreet: "",
        permanentCity: "",
        permanentState: "",
        permanentPincode: "",
        permanentCountry: "",
        residentialStreet: "",
        residentialCity: "",
        residentialState: "",
        residentialPincode: "",
        residentialCountry: "",
        alternativePhoneNumber: "",
        bankName: "",
        accountNumber: "",
        ifscCode: "",
        uan: "",
        esicNo: "",
        employeeType: ""
    })
    const { control, handleSubmit, setValue, reset } = useForm();

    useEffect(() => {
        for (let key in props.editableEmployee) {
            setValue(key, props.editableEmployee[key])
        }

    }, [props.editableEmployee])

    const [equalAdressCheckboxStatus, setEqualAdressCheckboxStatus] = useState<boolean>(false);

    const field = detailsField()
    const newEmployeeDetails = field.newEmployeeDetails
    const myState = useSelector((state: any) => state.allEmployee)
    const fetchApi = FetchApi()

    const handleField = (e: any, name: any) => {
        const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
        setFieldValue((d: any) => {
            return { ...d, [name]: value }
        })
        setValue(name, value)
    }

    const onSubmit = (data: any) => {
        snackbarService.next({ data: { open: true, severity: 'success', message: 'Please wait...' } })
        data.contact_no = String(data.contact_no) // JSON had string contact_no "9876543210" but the type might be string or number, wait, originally it was parseInt. Let me check the original.
        data.grossSalary = String(data.grossSalary) // JSON had string grossSalary "50000"
        
        // Convert designation to array as per JSON payload
        if (data.designation && !Array.isArray(data.designation)) {
            data.designation = [data.designation];
        }
        if (!props.renderEditEmployee) {
            setEqualAdressCheckboxStatus(false)
            const id = myState.employee.map((ele: any, key: number) => {
                return parseInt(ele.employee_id.substring(4))

            })
            const sortedNumbers = id.sort((a: number, b: number) => a - b);
            data['employee_id'] = `${prefix}${sortedNumbers[sortedNumbers.length - 1] + 1}`
            postEmployee(data).then(function (response: any) {

                if (response?.data.success) {
                    fetchApi.fetchAllEmployee()
                    snackbarService.next({ data: { open: true, severity: 'success', message: response.data.message } })
                } else {
                    snackbarService.next({ data: { open: true, severity: 'error', message: response.data.message } })

                }
            })

            reset();
            setFieldValue({
                name: "",
                contact_no: "",
                grossSalary: "",
                officialEmail: "",
                roles: '',
                personalEmail: "",
                designation: "",
                blood_group: "",
                DOB: "",
                agendaRequired: false,
                workupdateRequired: false,
                jobRole: "",
                educationalQualification: "",
                technologyStack: "",
                yearsOfExperience: "",
                lastOrganizationWorked: "",
                employeeTag: "",
                aadharNumber: "",
                panNumber: "",
                permanentStreet: "",
                permanentCity: "",
                permanentState: "",
                permanentPincode: "",
                permanentCountry: "",
                residentialStreet: "",
                residentialCity: "",
                residentialState: "",
                residentialPincode: "",
                residentialCountry: "",
                alternativePhoneNumber: "",
                bankName: "",
                accountNumber: "",
                ifscCode: "",
                uan: "",
                esicNo: "",
                employeeType: ""
            });
        }
    }

    return (
        <div className='main'>
            <Grid container className='main'>

                <div className='employee-registration-header flex-center height-30' >
                    <h3>Employee Details</h3>
                </div>
                <div className='cal-30 flex-center width-100'>
                    <div style={{ width: '500px', height: '100%' }}>

                        <Grid xs={12} container className='employee-registration-container'>
                            <form onSubmit={handleSubmit(onSubmit)} style={{ width: '100%', height: '100%' }}>
                                <Grid xs={12} item justifyContent='center' alignItems='center' style={{ height: 'calc(100% - 40px)' }}>
                                    <div className="form-container" >
                                        <div className='sub-from-container'>

                                            <div className='employee-registration-field-container'>
                                                {
                                                    newEmployeeDetails.map((ele: employeeDetailsProps, key: number) => {
                                                        return (
                                                            <div key={key} className='field-sub-container'>
                                                                {ele.type !== 'select' ? <>
                                                                    < label className='label'> {ele.label}</label>
                                                                    <Controller

                                                                        name={ele.name}
                                                                        control={control}
                                                                        render={({ field }) => (

                                                                            <>
                                                                                <input
                                                                                    type={ele.type}
                                                                                    {...field}
                                                                                    value={ele.type !== 'checkbox' ? (fieldValue[ele.name as keyof FieldValueProps] as any) : undefined}
                                                                                    checked={ele.type === 'checkbox' ? fieldValue[ele.name as keyof FieldValueProps] as boolean : undefined}
                                                                                    onChange={(e) => handleField(e, ele.name)}
                                                                                    required={ele.required}
                                                                                />

                                                                            </>
                                                                        )}
                                                                    />
                                                                </> : <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                                    <label className='label'>{ele.label}</label>
                                                                    <Controller
                                                                        name={ele.name}
                                                                        control={control}
                                                                        render={({ field }) => (
                                                                            <select
                                                                                {...field}
                                                                                onChange={(e) => handleField(e, ele.name)}
                                                                                value={(fieldValue[ele.name as keyof FieldValueProps] as string) || ''}
                                                                                required={ele.required}
                                                                            >
                                                                                <option value=''>Select...</option>

                                                                                {ele.options !== undefined
                                                                                    ? ele.options.map((el: employeeDetailsOptionProps, ind: number) => (
                                                                                        <option key={ind} value={el.value}>{el.label}</option>
                                                                                    ))
                                                                                    : ''}
                                                                            </select>
                                                                        )}
                                                                    />


                                                                </div>
                                                                }
                                                            </div>
                                                        )

                                                    })
                                                }

                                            </div >
                                        </div>
                                    </div>
                                </Grid>
                                <Grid xs={12} item style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '40px' }} >
                                    <ButtonWrapper title={`${!props.renderEditEmployee ? "Submit" : "Update"}`} id='submit-button' variant='contained' type='submit' backgroundColor='var(--primaryColor)' />
                                </Grid>
                            </form>
                        </Grid>
                    </div>
                </div>

            </Grid >
        </div >

    )
}

export default EmployeeRegistration